export default "__VITE_ASSET__SeNUjXdu__"